export const ENV = {
    ut_authority: 'https://dev-0d2xh410.us.auth0.com',
    ut_client_id: 'GAb6wGt0e5Sa5HmmyLwVEVDNRXQ61Bwv',
    dev_authority: 'https://uv-dev-test.us.auth0.com',
    dev_client_id: 'g3ijY9qhNYluzQOQVnnc1hyYi0uxtoXq',
} 